var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introMain",staticStyle:{"width":"100%"}},[_c('Section1',{attrs:{"id":"section1"}}),_c('Section2',{attrs:{"id":"section2"}}),_c('Section3',{attrs:{"id":"section3"}}),_c('Footer',{attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }